<template>
  <b-col v-if="isLoading">
    <Loader size="lg"></Loader>
  </b-col>
  <b-row v-else-if="$route.name === 'UserDataUpdate'">
    <b-col>
      <b-row v-if="item">
        <b-col class="mb-1">
          <template v-if="prevRoute.name === 'ContractorShow'">
            <router-link :to="{ name: 'ContractorShow', params: { id: retrieved['@id'] }}" class="btn btn-sm btn-default float-right">
              <span v-if="!mobileView">{{ $t('buttons.backToShow') }}</span>
              <i v-else class="far fa-arrow-alt-left"></i>
            </router-link>
          </template>
          <template v-else-if="routeName === 'ClientUpdate'">
            <router-link v-if="item && prevRoute && prevRoute.name === 'ClientShow'" :to="{ name: 'ClientShow', params: { id: retrieved['@id'] }}" class="btn btn-sm btn-default float-right">
              <span v-if="!mobileView">{{ $t('buttons.backToShow') }}</span>
              <i v-else class="far fa-arrow-alt-left"></i>
            </router-link>
            <router-link v-else :to="{ name: 'ClientList' }" class="btn btn-sm btn-default float-right">
              <span v-if="!mobileView">{{ $t('buttons.backToList') }}</span>
              <i v-else class="far fa-arrow-alt-left"></i>
            </router-link>
          </template>
          <template v-else-if="routeName === 'ServicemenUpdate'">
            <router-link v-if="item && prevRoute && prevRoute.name === 'ServicemanShow'" :to="{ name: 'ServicemanShow', params: { id: retrieved['@id'] }}" class="btn btn-sm btn-default float-right">
              <span v-if="!mobileView">{{ $t('buttons.backToShow') }}</span>
              <i v-else class="far fa-arrow-alt-left"></i>
            </router-link>
          </template>
          <template v-else>
            <router-link v-if="item && prevRoute && prevRoute.name === 'UserDataShow'" :to="{ name: 'UserDataShow', params: { id: retrieved['@id'] }}" class="btn btn-sm btn-default float-right">
              <span v-if="!mobileView">{{ $t('buttons.backToShow') }}</span>
              <i v-else class="far fa-arrow-alt-left"></i>
            </router-link>
            <router-link v-else :to="{ name: 'UserDataList' }" class="btn btn-sm btn-default float-right">
              <span v-if="!mobileView">{{ $t('buttons.backToShow') }}</span>
              <i v-else class="far fa-arrow-alt-left"></i>
            </router-link>
          </template>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <div class="card-body">
              <b-row>
                <b-col>
                  <UserDataForm
                          v-if="item"
                          :handle-submit="onSendForm"
                          :handle-update-field="updateField"
                          :values="item"
                          :errors="violations"
                          :initial-values="retrieved" />
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
  <b-row v-else>
    <b-col>
      <UserDataForm
        v-if="item"
        :handle-submit="onSendForm"
        :handle-update-field="updateField"
        :values="item"
        :errors="violations"
        :initial-values="retrieved" />
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import UserDataForm from './Form.vue'
import Loader from '../../Layout/Loader'

export default {
  components: {
    UserDataForm,
    Loader
  },

  props: ['idUserData'],

  data () {
    return {
      routeName: '',
      prevRoute: null,
      item: {}
    }
  },

  computed: {
    mobileView () {
      return this.$store.state.mobileView
    },
    ...mapGetters({
      isLoading: 'userdata/update/isLoading',
      error: 'userdata/update/error',
      deleteError: 'userdata/del/error',
      deleteLoading: 'userdata/del/isLoading',
      created: 'userdata/create/created',
      deleted: 'userdata/del/deleted',
      retrieved: 'userdata/update/retrieved',
      updated: 'userdata/update/updated',
      violations: 'userdata/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'UserDataList' })
    },

    updated: function (updated) {
      if (this.routeName === 'UserDataUpdate') {
        this.$router.push({ name: 'UserDataShow', params: { id: updated['@id'] } })
      } else if (this.routeName === 'ClientUpdate') {
        this.$router.push({ name: 'ClientShow', params: { id: updated['@id'] } })
      } else if (this.routeName === 'ServicemenUpdate') {
        this.$router.push({ name: 'ServicemenShow', params: { id: updated['@id'] } })
      }
    },

    retrieved: function (retrieved) {
      if (this.retrieved && this.retrieved.idClientType && this.retrieved.idClientType['@id']) {
        this.retrieved.idClientType = this.retrieved.idClientType['@id']
      }
    }
  },

  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.routeName = this.$route.name
    this.retrieve(
      this.idUserData ? this.idUserData : decodeURIComponent(this.$route.params.id)
    )
  },

  methods: {
    ...mapActions({
      createReset: 'userdata/create/reset',
      deleteItem: 'userdata/del/del',
      delReset: 'userdata/del/reset',
      retrieve: 'userdata/update/retrieve',
      updateReset: 'userdata/update/reset',
      update: 'userdata/update/update',
      updateRetrieved: 'userdata/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this userdata ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      let item = this.$store.state.userdata.update.retrieved
      item.phoneMobileToSms = parseInt(item.phoneMobileToSms)
      if (item.users) {
        delete item.users
      }
      item.userDataTags = item.userDataTags.map(entry => {
        return { '@id': entry['@id'], idTag: entry.value, idUserData: item['@id'], text: entry.text, value: entry.value }
      })
      this.$store.state.userdata.update.retrieved = item
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
